var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cafe_ranking", attrs: { role: "main" } },
    [
      _c("cafe-menu", {
        directives: [
          {
            name: "tiara",
            rawName: "v-tiara",
            value: _vm.tiaraObj.mainCategory,
            expression: "tiaraObj.mainCategory",
          },
        ],
        ref: "rankingCategory",
        attrs: {
          name: "카페 랭킹",
          "has-buttons": true,
          "menu-list": _vm.mainCategories,
          "initial-index": _vm.initialIndex.main,
          "wrap-class": "feature_ranking",
        },
        on: { select: _vm.onMainCategorySelect },
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "cMain" } }, [
        _c(
          "div",
          { attrs: { id: "mArticle" } },
          [
            _c(
              "div",
              { staticClass: "sub_util" },
              [
                _vm.isTotalCategory
                  ? _c("div", { staticClass: "ask_cafe" }, [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tiara",
                              rawName: "v-tiara",
                              value: _vm.tiaraObj.cafeRankInfo,
                              expression: "tiaraObj.cafeRankInfo",
                            },
                          ],
                          staticClass: "link_ask",
                          attrs: {
                            target: "_blank",
                            href: "//cs.daum.net/faq/36/6030.html#21597",
                          },
                        },
                        [_vm._v("카페랭킹이란?")]
                      ),
                    ])
                  : _vm.subCategories.length
                  ? _c("cafe-sub-menu", {
                      directives: [
                        {
                          name: "tiara",
                          rawName: "v-tiara",
                          value: _vm.tiaraObj.subCategory,
                          expression: "tiaraObj.subCategory",
                        },
                      ],
                      attrs: {
                        "menu-list": _vm.subCategories,
                        "watch-menu": true,
                        "initial-index": _vm.initialIndex.sub,
                      },
                      on: { select: _vm.onSubCategorySelect },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ranking_opt" },
                  [
                    _vm.isTotalCategory
                      ? _c("dropdown", {
                          attrs: { name: "level", options: _vm.levels },
                          on: { select: _vm.onLevelSelect },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("dropdown", {
                      attrs: { name: "sortOption", options: _vm.sortOptions },
                      on: { select: _vm.onSortOptionSelect },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "ranking-section",
              _vm._l(_vm.firstRankingList, function (cafe, index) {
                return _c("ranking-item", {
                  directives: [
                    {
                      name: "tiara",
                      rawName: "v-tiara",
                      value: _vm.tiaraObj.rankingItem,
                      expression: "tiaraObj.rankingItem",
                    },
                  ],
                  key: "ranking-first-rank-" + index,
                  attrs: { rank: index, "cafe-info": cafe },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "ranking-section",
              _vm._l(_vm.secondRankingList, function (cafe, index) {
                return _c("ranking-item", {
                  directives: [
                    {
                      name: "tiara",
                      rawName: "v-tiara",
                      value: _vm.tiaraObj.rankingItem,
                      expression: "tiaraObj.rankingItem",
                    },
                  ],
                  key: "ranking-second-rank-" + index,
                  attrs: { rank: index + _vm.sliceLength, "cafe-info": cafe },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }